// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".redirect-div{margin-top:40px}.redirect-div .redirect-image{max-width:300px;max-height:300px}.redirect-div .redirect-text{font-weight:bold;font-size:20px;margin-top:23px;color:#46aeff}.redirect-div .redirect-logo{width:250px;margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
